// 中文语言包
var zhCN = {
    type: 'zh_CN',
    waterfall: {
        total: '总计',
    },
    calendar: {
        monthAbbr: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月',
        ],
        dayOfWeekAbbr: ['日', '一', '二', '三', '四', '五', '六'],
    },
};
export default zhCN;
